import React, { useEffect, useRef, useState } from "react";
import { FaFilePdf } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { User_Authentication } from "../../../user_authentication/User_Authentication";
import {
  Get_Pooja_Invoice_Details,
  Get_User_Booked_Pooja_List,
} from "../../../api/pooja/Pooja";
import Loader from "../../../loader/Loader";
import User_Dashbaord_Common_Section from "../../pages/user_dashboard/user_dashboard_common_section/User_Dashbaord_Common_Section";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettingData } from "../../../redux/actions/settingAction";
import { IMG_BASE_URL } from "../../../config/Config";

export default function PoojainvoicePage() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const invoiceRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [booking, setBooking] = useState(null);

  const bookingId = Number(id);
  const { settingData } = useSelector((state) => state?.settingdata || []);

  useEffect(() => {
    dispatch(fetchSettingData());
  }, [dispatch]);

  useEffect(() => {
    const fetchBooking = async () => {
      setIsLoading(true);
      try {
        const token = User_Authentication();

        const response = await Get_Pooja_Invoice_Details(bookingId, {
          Authorization: `Bearer ${token}`,
        });

        if (response?.data?.status === 200) {
          setBooking(response?.data?.data?.pooja);
        } else {
          const listResponse = await Get_User_Booked_Pooja_List({
            Authorization: `Bearer ${token}`,
          });

          const match = listResponse?.data?.data?.pooja_list?.find(
            (item) => Number(item.id) === bookingId,
          );

          if (match) setBooking(match);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    if (bookingId) fetchBooking();
  }, [bookingId]);

  const formatTime = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    const intHours = parseInt(hours, 10);
    const ampm = intHours >= 12 ? "PM" : "AM";
    const formattedHours = intHours % 12 || 12;
    return `${formattedHours}:${minutes} ${ampm}`;
  };

  const invoice = {
    orderNo: booking?.orderNo,
    date: booking?.created_at?.slice(0, 10),
    location: booking?.location,
    poojapackage: booking?.poojapackage?.name,
    description: booking?.title,
    paymentmethod: booking?.paymentmethod,
    paymentstatus: booking?.payment_status,
    numberofpandit: booking?.poojapackage?.number_of_pandit,
    numberofday: booking?.poojapackage?.number_of_day,
    duration: booking?.poojapackage?.duration,
    total: Number(booking?.price || 0),
    poojadate: booking?.pooja_date,
    poojatime: booking?.from_time,
    panditName: booking?.astro?.name || booking?.panditName, // field not coming from backend
    bookingStatus: booking?.status === 1 ? "Pending" : booking?.status === 2 ? "Processing" : booking?.status === 3 ? "Complete" : "Canceled",
  };



  const downloadInvoice = async () => {
    const input = invoiceRef.current;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const width = pdf.internal.pageSize.getWidth();
    const height = (canvas.height * width) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, width, height);
    pdf.save(`Invoice-${invoice.orderNo}.pdf`);
  };

  return (
    <>
      <Header />

      {isLoading ? (
        <Loader />
      ) : (
        <div className="bg-gray-100 py-10">
          <div className="max-w-6xl mx-auto flex gap-6">
            <User_Dashbaord_Common_Section />

            <div className="w-full flex flex-col items-center">
              {/* INVOICE */}
              <div
                ref={invoiceRef}
                className="bg-white shadow-2xl rounded-xl p-10 w-full text-gray-800 border border-gray-200"
              >
                {/* Header */}
                <div className="flex justify-between items-start border-b pb-6">
                  <div className="flex items-center gap-4">
                    {settingData && settingData[0]?.header_logo ? (
                      <img
                        src={`${IMG_BASE_URL}${settingData[0].header_logo}`}
                        alt="Company Logo"
                        className="h-12 object-contain"
                      />
                    ) : (
                      <h2 className="text-2xl font-bold text-red-700">Omens</h2>
                    )}
                  </div>

                  <div className="text-right text-sm space-y-1">
                    <p>
                      <b className="text-gray-500">Order No:</b> <span className="font-semibold text-gray-900">{invoice.orderNo}</span>
                    </p>
                    <p>
                      <b className="text-gray-500">Invoice Date:</b> <span className="font-semibold text-gray-900">{invoice.date}</span>
                    </p>
                    <p>
                      <b className="text-gray-500">Payment Status:</b>{" "}
                      <span className={`px-2 py-0.5 rounded text-xs font-bold uppercase ${invoice.paymentstatus?.toLowerCase() === 'paid' || invoice.paymentstatus?.toLowerCase() === 'success'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-yellow-100 text-yellow-800'
                        }`}>
                        {invoice.paymentstatus || "Pending"}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="mt-2">
                  <h1 className="text-3xl font-extrabold tracking-tight text-gray-900">Pooja Invoice</h1>
                </div>

                {/* Details Section */}
                <div className="grid grid-cols-2 gap-8 mt-8 text-sm">
                  {/* Left Column: Pooja Details */}
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-100 space-y-3">
                    <h3 className="font-bold text-gray-900 border-b pb-2 text-base flex items-center gap-2">
                      <span className="w-2.5 h-2.5 rounded-full bg-red-600"></span>
                      Pooja & Package Info
                    </h3>
                    <div className="space-y-2">
                      <p className="flex justify-between">
                        <span className="text-gray-500">Pooja Name:</span>
                        <span className="font-semibold text-gray-950 text-right">{invoice.description}</span>
                      </p>
                      <p className="flex justify-between">
                        <span className="text-gray-500">Package Details:</span>
                        <span className="font-semibold text-gray-950 text-right">{invoice.poojapackage}</span>
                      </p>
                      <p className="flex justify-between">
                        <span className="text-gray-500">Duration:</span>
                        <span className="font-semibold text-gray-950 text-right">{invoice.duration || "N/A"}</span>
                      </p>
                      <p className="flex justify-between">
                        <span className="text-gray-500">Location:</span>
                        <span className="font-semibold text-gray-950 text-right">{invoice.location || "N/A"}</span>
                      </p>
                    </div>
                  </div>

                  {/* Right Column: Pandit & Schedule */}
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-100 space-y-3">
                    <h3 className="font-bold text-gray-900 border-b pb-2 text-base flex items-center gap-2">
                      <span className="w-2.5 h-2.5 rounded-full bg-red-600"></span>
                      Pandit & Schedule Info
                    </h3>
                    <div className="space-y-2">
                      <p className="flex justify-between">
                        <span className="text-gray-500">Pandit Name:</span>
                        <span className="font-semibold text-gray-950 text-right">{invoice.panditName || "Not Assigned"}</span>
                      </p>
                      <p className="flex justify-between">
                        <span className="text-gray-500">Pooja Date & Time:</span>
                        <span className="font-semibold text-gray-950 text-right">
                          {invoice.poojadate} {invoice.poojatime ? `at ${formatTime(invoice.poojatime)}` : ""}
                        </span>
                      </p>
                      <p className="flex justify-between">
                        <span className="text-gray-500">No. of Pandits:</span>
                        <span className="font-semibold text-gray-950 text-right">{invoice.numberofpandit || 1}</span>
                      </p>
                      <p className="flex justify-between">
                        <span className="text-gray-500">No. of Days:</span>
                        <span className="font-semibold text-gray-950 text-right">{invoice.numberofday || 1}</span>
                      </p>
                    </div>
                  </div>
                </div>

                {/* Table */}
                <div className="mt-8">
                  <table className="w-full border border-collapse rounded-lg overflow-hidden">
                    <thead className="bg-gray-100 border-b">
                      <tr>
                        <th className="p-3 text-left font-semibold text-gray-700">Pooja Name / Description</th>
                        <th className="p-3 text-center font-semibold text-gray-700">Pooja Date</th>
                        <th className="p-3 text-right font-semibold text-gray-700">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b hover:bg-gray-50/50">
                        <td className="p-3">
                          <p className="font-semibold text-gray-900">{invoice.description}</p>
                          <p className="text-xs text-gray-500 mt-0.5">Package: {invoice.poojapackage}</p>
                        </td>
                        <td className="p-3 text-center text-gray-800">{invoice.poojadate}</td>
                        <td className="p-3 text-right font-semibold text-gray-900">₹{invoice.total}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Summary */}
                <div className="flex justify-end mt-6">
                  <div className="w-80 space-y-2 text-sm">
                    <div className="flex justify-between text-gray-600">
                      <span>Subtotal</span>
                      <span className="font-medium text-gray-900">₹{invoice.total}</span>
                    </div>

                    <div className="border-t pt-2 flex justify-between font-bold text-lg text-gray-900">
                      <span>Total</span>
                      <span>₹{invoice.total}</span>
                    </div>
                  </div>
                </div>

                {/* Note */}
                <div className="mt-8 bg-gray-50 p-4 rounded border border-gray-100">
                  <p className="font-semibold text-gray-950">Note</p>
                  <p className="text-gray-600 mt-1">Thank you for booking your pooja with us. If you have any questions, please contact our support team.</p>
                </div>
              </div>

              {/* BUTTON */}
              <button
                onClick={downloadInvoice}
                className="mt-4 flex gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg"
              >
                <FaFilePdf /> Download PDF
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}
